import React from 'react';
import PropTypes from 'prop-types';
import {Redirect} from 'react-router-dom';

import {connect} from '@stubhub/react-store-provider';

import * as controller from './dismiss-controller';

class LoginStateHandler extends React.Component {
  static contextTypes = {
    cookies: PropTypes.object,
  };
  componentDidMount() {
    if (
      !this.props.primaryContact ||
      (this.props.primaryContact &&
        Object.keys(this.props.primaryContact).length === 0 &&
        this.props.primaryContact.constructor === Object)
    ) {
      let {cookies} = this.context;
      let userGuid = cookies && cookies.get('session_userGUID');
      this.props.getUserContact &&
        typeof this.props.getUserContact === 'function' &&
        this.props.getUserContact(userGuid);
    }
  }

  render() {
    if (this.props.loginType === 'CLOSE') {
      return <Redirect to="/" />;
    } else {
      return null;
    }
  }
}

export default connect(controller)(LoginStateHandler);
